import styled from 'styled-components';

export const listItemChildPadding = '15px 3px 15px;';

export default styled.li<{ hexColor?: string }>`
    display: block;
    text-decoration: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20};
    &:last-child {
        border-bottom: none;
    }
    color: ${({ hexColor, theme }) => hexColor || theme.colors.charcoal100};
    & > * {
        padding: ${listItemChildPadding};
    }
`;
